import { EndpointSetting } from "@/constants/app/type"
import { HotelState } from "../type"
import { parseFacilitiesHotel } from "@/utils/hotel/parseFacilitiesHotel"
import { parseResourceRoom } from "@/utils/hotel/parseResouceRoom"

export const callbackHotelResources: EndpointSetting['caller'] = (
  state: HotelState,
  action: any,
  endpointName: any
) => {
  state.hotels_detail_resource.loading = false
  state.hotels_detail_resource.called = true
  state.hotels_detail_resource.error = null
  state.hotels_detail_resource.data = {
    ...action.payload,
    roomData: (action.payload?.roomData || []).map((resource: any) => ({
      ...resource,
      hotelRoomTypePictures: {
        ...resource.hotelRoomTypePictures,
        hotelRoomTypePicture: typeof resource.hotelRoomTypePictures.hotelRoomTypePicture === 'string'
          ? [resource.hotelRoomTypePictures.hotelRoomTypePicture]
          : resource.hotelRoomTypePictures.hotelRoomTypePicture
      }
    }))
  }

  if (!!state.hotels_detail.data?.hotelId) {
    const facilities = state.hotels_detail.data.facilities

    state.hotels_detail.data = {
      ...state.hotels_detail.data,
      searchResponse: {
        ...state.hotels_detail.data.searchResponse,
        rooms: state.hotels_detail.data.searchResponse.roomIds.reduce((obj, roomId) => {
          const resource = state.hotels_detail_resource.data.roomData.find((r: any) => `${r.hotelRoomTypeId}` === `${roomId}`)

          obj[roomId] = state.hotels_detail.data.searchResponse.rooms[roomId].map((opt) => ({
            ...opt,
            resource: !!opt.resource ? opt.resource : resource ? parseResourceRoom(resource, facilities) : null
          }))
          return obj
        }, {})
      }

    }
  }
}